import { FONT_BRIGHTNESS } from '@hivebrite/design-system/Theme';

import { useDefaultAppContexts } from 'hb-react/frontoffice/contexts/withDefaultAppContexts';
import type { Network } from 'hb-react/types';

export interface PageHeaderTheme {
  backgroundColor?: string;
  fontBrightness?: (typeof FONT_BRIGHTNESS)[keyof typeof FONT_BRIGHTNESS];
  themeName: string;
}

interface UsePageHeaderProps {
  network?: Network;
  showPicture?: boolean;
}

type UsePageHeaderTheme = ({
  network,
  showPicture,
}: UsePageHeaderProps) => PageHeaderTheme;

// Page header can be customize by the Admin in the BO
const usePageHeaderTheme: UsePageHeaderTheme = ({
  network,
  showPicture,
} = {}) => {
  const { currentNetwork } = useDefaultAppContexts();

  const networkData = network || currentNetwork;

  return {
    backgroundColor: networkData?.theming?.fo?.fo_page_header_background_color,
    // Don't change fontBrightness when picture is displayed
    fontBrightness: showPicture
      ? FONT_BRIGHTNESS.DARK
      : networkData?.theming?.fo?.fo_page_header_font_brightness,
    themeName: 'fo',
  };
};

export default usePageHeaderTheme;
